import React from 'react';
const CHECKOUT_URL = 'https://betterdailyguides.com/cart/51907888972078:1';
const valueItems = [{
  item: '📘 Su Primer Año — Protocolo B.E.B.E. 365 (60 páginas)',
  value: '$97'
}, {
  item: '🌙 BONO 1: Noches de Oro',
  value: '$57'
}, {
  item: '🧠 BONO 2: Pequeño Genio (52 actividades)',
  value: '$37'
}, {
  item: '📅 BONO 3: Tu Bebé Mes a Mes',
  value: '$27'
}, {
  item: '💰 BONO 4: Ahorra $2000 en su Primer Año',
  value: '$17'
}];
export function ValueStackSection() {
  const handleCTAClick = () => {
    console.log('InitiateCheckout tracked');
  };
  return <section className="bg-gradient-to-br from-[#3D2B1F] to-[#6B4C3B] text-[#FAF7F2] py-16 px-5" data-id="element-274">
      <div className="max-w-[900px] mx-auto" data-id="element-275">
        <div className="text-center mb-10" data-id="element-276">
          <span className="inline-block bg-white/10 text-[#C9A96E] text-[11px] tracking-widest uppercase px-4 py-1.5 rounded-full mb-4 font-sans font-bold" data-id="element-277">
            Todo lo que recibes hoy
          </span>
          <h2 className="text-3xl md:text-4xl text-[#FAF7F2] leading-tight" data-id="element-278">
            El Bundle Completo B.E.B.E. 365
          </h2>
        </div>

        <table className="w-full border-collapse mb-10" data-id="element-279">
          <tbody data-id="element-280">
            {valueItems.map((item, idx) => <tr key={idx} className="border-b border-white/10 last:border-b-0" data-id="element-281">
                <td className="py-4 px-3 font-sans text-sm text-[rgba(250,247,242,0.9)]" data-id="element-282">
                  {item.item}
                </td>
                <td className="py-4 px-3 text-[#C9A96E] font-bold text-right text-base" data-id="element-283">
                  {item.value}
                </td>
              </tr>)}
            <tr className="border-t-2 border-[rgba(183,110,121,0.4)]" data-id="element-284">
              <td className="pt-5 px-3 font-sans text-lg text-[#FAF7F2] font-bold" data-id="element-285">
                💎 VALOR TOTAL
              </td>
              <td className="pt-5 px-3 text-[#FAF7F2] font-bold text-right text-lg" data-id="element-286">
                $235
              </td>
            </tr>
          </tbody>
        </table>

        <div className="bg-white/5 rounded-3xl p-9 border border-[rgba(183,110,121,0.3)] text-center" data-id="element-287">
          <div className="text-xl text-[rgba(250,247,242,0.5)] line-through mb-2 font-sans" data-id="element-288">
            Valor total: $235
          </div>
          <div className="text-6xl md:text-7xl font-bold text-[#FAF7F2] leading-none mb-1.5" data-id="element-289">
            $14.97
          </div>
          <div className="inline-block bg-[#B76E79] text-white text-sm font-bold px-4 py-1.5 rounded-full mb-6 font-sans" data-id="element-290">
            💰 AHORRAS $220.03 — 94% DE DESCUENTO
          </div>

          <a href={CHECKOUT_URL} onClick={handleCTAClick} className="inline-block bg-gradient-to-r from-[#C9A96E] to-[#B76E79] text-white text-lg font-bold py-5 px-12 rounded-full tracking-wide shadow-xl hover:shadow-2xl transition-all hover:-translate-y-1 font-sans uppercase animate-cta-pulse" data-id="element-291">
            ⚡ SÍ, QUIERO EL ACCESO COMPLETO POR $14.97 →
          </a>

          <div className="flex justify-center gap-5 flex-wrap mt-5 text-xs text-[rgba(250,247,242,0.6)] font-sans" data-id="element-292">
            <span className="flex items-center gap-1.5" data-id="element-293">
              🔒 Pago Seguro SSL
            </span>
            <span className="flex items-center gap-1.5" data-id="element-294">
              📥 Acceso Instantáneo
            </span>
            <span className="flex items-center gap-1.5" data-id="element-295">
              ↩️ Garantía 30 Días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-296">
              💳 Visa · PayPal · Mastercard
            </span>
          </div>
        </div>
      </div>
    </section>;
}